const getIsLoading = state => state.isLoading;

const isLoadingSelectors = {
  getIsLoading,
};

export default isLoadingSelectors;
